import sortLinks from './sortLinks';

export const utils = {
  sortLinks,
};
